var keys = {
    AUTH_login: "AUTH_login",
    AUTH_forgot: "AUTH_forgot",
    AUTH_clickHere: "AUTH_clickHere",
    AUTH_rightsReserved: "AUTH_rightsReserved",
    AUTH_privacy: "AUTH_privacy",
    AUTH_imprint: "AUTH_imprint",
    AUTH_reset: "AUTH_reset",
    AUTH_resetHelptext: "AUTH_resetHelptext",
    AUTH_resetButtonLabel: "AUTH_resetButtonLabel",
    AUTH_resetError: "AUTH_resetError",
    AUTH_resetSuccess: "AUTH_resetSuccess",
    AUTH_alreadyHaveAccount: "AUTH_alreadyHaveAccount",
    AUTH_signup: "AUTH_signup",
    AUTH_gethelp: "AUTH_gethelp",
    AUTH_getHelpLink: "AUTH_getHelpLink",
    AUTH_clickAboveButtons: "AUTH_clickAboveButtons",
    AUTH_termsAndService: "AUTH_termsAndService",
    AUTH_metaTerms: "AUTH_metaTerms",
    AUTH_forWhatsApp: "AUTH_forWhatsApp",
    AUTH_360terms: "AUTH_360terms",
    AUTH_create: "AUTH_create",
    AUTH_login360: "AUTH_login360",
    AUTH_email: "AUTH_email",
    AUTH_password: "AUTH_password",
    AUTH_loginEmail: "AUTH_loginEmail",
    AUTH_continueEmail: "AUTH_continueEmail",
    AUTH_signupTerms: "AUTH_signupTerms",
    AUTH_checkEmail: "AUTH_checkEmail",
    AUTH_create360Account: "AUTH_create360Account",
    AUTH_otpTextOne: "AUTH_otpTextOne",
    AUTH_otpTextTwo: "AUTH_otpTextTwo",
    AUTH_otpTextThree: "AUTH_otpTextThree",
    AUTH_otp: "AUTH_otp",
    AUTH_enterOtp: "AUTH_enterOtp",
    AUTH_namePlaceholder: "AUTH_namePlaceholder",
    AUTH_nameLabel: "AUTH_nameLabel",
    AUTH_createAccountEmail: "AUTH_createAccountEmail",
    AUTH_otpWindowMessage: "AUTH_otpWindowMessage",
    AUTH_createAccount: "AUTH_createAccount",
    AUTH_signupPriceList: "AUTH_signupPriceList",
    AUTH_redirectMessage: "AUTH_redirectMessage",
    AUTH_visitNewHub: "AUTH_visitNewHub",
    AUTH_newHubInfoMessage: "AUTH_newHubInfoMessage",
    AUTH_governmentAgency: "AUTH_governmentAgency",
    AUTH_organizationIRepresent: "AUTH_organizationIRepresent",
    AUTH_chooseFromList: "AUTH_chooseFromList",
    AUTH_governmentalAgencyApproval: "AUTH_governmentalAgencyApproval",
    AUTH_companyEmail: "AUTH_companyEmail",
    AUTH_termsOfServiceSignUp: "AUTH_termsOfServiceSignUp",
    AUTH_newAccount: "AUTH_newAccount",
    AUTH_twoFactorAuth: "AUTH_twoFactorAuth",
    AUTH_OTPSent: "AUTH_OTPSent",
    AUTH_dontHaveAccount: "AUTH_dontHaveAccount",
    AUTH_signIn: "AUTH_signIn",
    AUTH_resetHere: "AUTH_resetHere",
    AUTH_ResetPasswordMessage: "AUTH_ResetPasswordMessage",
    AUTH_wantToCancel: "AUTH_wantToCancel",
    AUTH_backToSignIn: "AUTH_backToSignIn",
    AUTH_emailSentTo: "AUTH_emailSentTo",
    AUTH_checkInbox: "AUTH_checkInbox",
    AUTH_GoBackToSignIn: "AUTH_GoBackToSignIn",
    AUTH_logOut: "AUTH_logOut",
    AUTH_min8Characters: "AUTH_min8Characters",
    AUTH_noFacebookEmail: "AUTH_noFacebookEmail",
    AUTH_logIn: "AUTH_logIn",
    AUTH_instructions: "AUTH_instructions",
    AUTH_passwordNew: "AUTH_password",
    AUTH_emailVerification: "AUTH_emailVerification",
    AUTH_FBLogin: "AUTH_FBLogin",
    AUTH_company: "AUTH_company",
    AUTH_vatId: "AUTH_vatId",
    AUTH_incorrectVatId: "AUTH_incorrectVatId",
    AUTH_fbDisabledTooltip: "AUTH_fbDisabledTooltip",
    AUTH_otpTitle: "AUTH_otpTitle",
    AUTH_otpDescription: "AUTH_otpDescription",
    AUTH_otpDescriptionFallback: "AUTH_otpDescriptionFallback",
    AUTH_switchActivePartner: "AUTH_switchActivePartner",
    AUTH_searchPartner: "AUTH_searchPartner",
    AUTH_cannotSeeEmail: "AUTH_cannotSeeEmail",
    AUTH_addBusinessDetails: "AUTH_addBusinessDetails",
    AUTH_emailIsNotVerified: "AUTH_emailIsNotVerified",
    AUTH_emailNotVerifiedYet: "AUTH_emailNotVerifiedYet",
    AUTH_checkVerification: "AUTH_checkVerification",
    AUTH_emailVerifiedSuccess: "AUTH_emailVerifiedSuccess",
    AUTH_redirectingIn: "AUTH_redirectingIn",
    AUTH_signupDescription: "AUTH_signupDescription",
    AUTH_addCompanyDetails: "AUTH_addCompanyDetails",
    AUTH_addPartnerDetails: "AUTH_addPartnerDetails",
    AUTH_createPartnerAccount: "AUTH_createPartnerAccount",
    AUTH_errorWithAccount: "AUTH_errorWithAccount",
    AUTH_changeUser: "AUTH_changeUser",
    AUTH_addUser: "AUTH_addUser",
    AUTH_noPermissionAddUser: "AUTH_noPermissionAddUser",
    AUTH_wrongPartnerIdMessage: "AUTH_wrongPartnerIdMessage",
};
export default keys;
//# sourceMappingURL=data:application/json;base64,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